import { DealModerationCardEntity } from 'src/entities/deal';
import { AdminFeedbackViewModel } from '@common/model/admin/catalog/feedback/view';
import { coreDealApi } from '@cp/entities/deal';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { useProcessingAndReviews } from '../processingAndReviews';
import { ReviewFooter } from './reviewFooter';
import { ClickFeature } from '.';

interface ReviewItemProps extends AdminFeedbackViewModel {
  onClick: ClickFeature;
}

export const ReviewItem = (props: ReviewItemProps) => {
  const { form } = useProcessingAndReviews();
  const { data, isLoading, isFetching } = coreDealApi.endpoints.getOne.useQuery(
    { dealId: props.subjectDealId! },
    {
      skip: !props.subjectDealId,
    },
  );

  const createdAt = new Date(props.createdAt);
  const careerType = form.getValues('careerId');

  if (isLoading || isFetching || !data) {
    return <Skeleton height={152} width="100%" />;
  }

  if (!props.subjectDealId || !data.subjectConsumer || !data.subjectProvider) {
    return null;
  }

  const author = props.authorId === data.subjectConsumerClientId ? data.subjectConsumer : data.subjectProvider;
  const recipient = props.authorId === data.subjectConsumerClientId ? data.subjectProvider : data.subjectConsumer;
  const from = `${author.details.name} ${author.details.surname ? author.details.surname[0] + '.' : ''}`.trim();
  const to = `${recipient.details.name} ${!!recipient.details.surname ? recipient.details.surname[0] + '.' : ''}`.trim();
  const changeTypeOfClients = props.authorId !== data.subjectConsumerClientId;

  return (
    <DealModerationCardEntity
      careerType={careerType}
      changeTypeOfClients={changeTypeOfClients}
      createdAt={createdAt}
      fake={props.fake}
      from={props.authorName || from}
      onClick={props.onClick(data)}
      slots={{ foot: <ReviewFooter feedback={props} /> }}
      to={to}
    />
  );
};

export const withRenderReviewItem = (onClick: ClickFeature) => (item: AdminFeedbackViewModel) => (
  <ReviewItem key={item.id} onClick={onClick} {...item} />
);
